import { ruleTitle } from '../lib/activeRules.ts'
import type { Finding, Review } from '../lib/api.ts'
import { CHECK_LABEL, label } from '../lib/vocabulary.ts'

/**
 * Under a row in the Correção view (#439): what was asked to be fixed there,
 * and what the pharmacist said about it.
 *
 * One line per marked finding, beneath the row it belongs to, rather than a
 * list of the finding's full sentences at the top: with ten corrections that
 * list was ten paragraphs to read before reaching the first row, and the row
 * itself already shows what the receita and the system say.
 */
export function CorrectionAsked({
  findings,
  decisions,
}: {
  findings: readonly Finding[]
  decisions: ReadonlyMap<string, Review>
}) {
  const asked = findings.flatMap((finding) => {
    const decision = decisions.get(finding.fingerprint)
    return decision?.decision === 'corrected' ? [{ finding, decision }] : []
  })
  if (asked.length === 0) return null

  return (
    <ul className="flex flex-col gap-0.5 py-1 pr-3 pl-10">
      {asked.map(({ finding, decision }) => {
        const notes = decision.notes?.trim()
        return (
          <li key={finding.fingerprint} className="text-tSmall text-text-weak">
            <span aria-hidden="true">↳ </span>
            <span className="text-text-strong font-medium">
              Corrigir:{' '}
              {/* A rule is named: "regra operacional" does not say which of
                  seventeen, and on an ativo's row nothing else does (#549). */}
              {ruleTitle(finding) ?? label(CHECK_LABEL, finding.check).toLocaleLowerCase('pt-BR')}
            </span>
            {notes !== undefined && notes !== '' && (
              <span className="text-text-strong"> — “{notes}”</span>
            )}
            <span> · {decision.verifier_email}</span>
          </li>
        )
      })}
    </ul>
  )
}
